/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccounts {
    getFixupPrototypeFunction() { return CloudAccounts.fixupPrototype; }

    static newInstance(model: Partial<CloudAccounts>): CloudAccounts {
        let obj = Object.assign(new CloudAccounts(), model);
        CloudAccounts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccounts>): CloudAccounts {
        if (!model) return null;
        return CloudAccounts.newInstance(<CloudAccounts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccounts) {
        if (!obj) return;

        models.CloudAccounts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccounts): boolean {
        Object.setPrototypeOf(obj, CloudAccounts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Response status on cloud accounts fetched successfully
     */
    status: string;

    /**
     * Cloud accounts fetched successfully
     */
    message: string;

    /**
     * cloud account details
     */
    cloud_accounts: any;

}
